import { __spreadProps, __spreadValues } from './chunk-D6FLC3TD.mjs';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { jsx, jsxs } from 'react/jsx-runtime';

var LoadingBackdrop = (props) => {
  const { message } = props;
  return /* @__PURE__ */ jsx(Backdrop, __spreadProps(__spreadValues({}, props), { open: true, children: /* @__PURE__ */ jsxs(Box, { textAlign: "center", children: [
    /* @__PURE__ */ jsx(CircularProgress, {}),
    !!message && /* @__PURE__ */ jsx(Typography, { color: "common.white", children: message })
  ] }) }));
};
var LoadingBackdrop_default = LoadingBackdrop;

export { LoadingBackdrop_default };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-BAWCK7NB.mjs.map